import Media from '@/components/media';

import styles from './full-bleed-image.module.scss';

export default function FullBleedImage({ data }: { data: any }) {
  return (
    <div className="full-bleed-image">
      <div className={styles.desktop}>
        <Media media={data.image} />
      </div>

      <div className={styles.mobile}>
        <Media media={data.mobile} />
      </div>
    </div>
  );
}
